<template>
    <a-drawer :title="$t('submission.email_history_detail.email_send_record' /*发送邮件记录*/)" width="1100px" placement="right" :closable="true" :visible="visible" @close="handleCancelEvent">
        <div>
            <!--    搜索条件    -->
            <div class="table-page-search-wrapper">
                <a-form layout="inline" class="hidden">
                    <a-row :gutter="[10, 10]">
                        <a-col :xl="6" :lg="6" :xs="12" style="text-align: left">
                            <a-form-item :label="$t('submission.email_history_detail.email' /*邮箱*/)">
                                <a-input :placeholder="$t('submission.email_history_detail.enter_email' /*请输入邮箱*/)" v-model="searchParams.target" />
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :lg="6" :xs="12" style="text-align: left">
                            <a-form-item :label="$t('submission.email_history_detail.status' /*状态*/)">
                                <a-select v-model="searchParams.status">
                                    <a-select-option value="">{{ $t('submission.email_history_detail.all' /*全部*/) }}</a-select-option>
                                    <a-select-option :value="0">{{ $t('submission.email_history_detail.not_send' /*未发送*/) }}</a-select-option>
                                    <a-select-option :value="1">{{ $t('submission.email_history_detail.send_success' /*发送成功*/) }}</a-select-option>
                                    <a-select-option :value="2">{{ $t('submission.email_history_detail.send_failed' /*发送失败*/) }}</a-select-option>
                                    <a-select-option :value="3">{{ $t('submission.email_history_detail.send_processing' /*发送中*/) }}</a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :lg="6" :xs="12" style="text-align: left">
                            <a-button type="primary" @click="handleSearch">{{ $t('submission.email_history_detail.query' /*查询*/) }}</a-button>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-alert :message="$t('submission.email_history_detail.total_count', { totalCount } /*总计：{totalCount}条*/)" type="info" show-icon />
            <a-tabs></a-tabs>
            <a-tabs v-model="tabIndex" tab-position="top" @change="handleChangeTypeEvent">
                <a-tab-pane :key="1" :tab="$t('submission.email_history_detail.email_send_record' /*邮件发送记录*/)"></a-tab-pane>
                <a-tab-pane :key="2" :tab="$t('submission.email_history_detail.email_template_record' /*发送模板记录*/)"></a-tab-pane>
            </a-tabs>
            <!--    表格    -->
            <!-- 邮件发送记录 -->
            <template v-if="tabIndex == 1">
                <s-table ref="table" class="mt15" size="default" :rowKey="record => record.email_id" :columns="columns" :data="loadData" :showPagination="true" :scroll="{ x: 1500 }">
                    <template slot="num" slot-scope="text, record">
                        <b class="error-color">{{ record.num }}</b>
                    </template>
                    <template slot="send_time" slot-scope="text, record">
                        <span>{{ record.send_time }}</span>
                    </template>
                    <template slot="status" slot-scope="text, record">
                        <a-badge v-if="record.status == 1" :text="record.status_desc" status="success" />
                        <a-badge v-else-if="record.status == 3" :text="record.status_desc" status="blue" />
                        <a-badge v-else-if="record.status == 2" :text="record.status_desc" status="error" />
                        <a-badge v-else-if="record.status == 0" :text="record.status_desc" status="error" />
                    </template>
                    <template slot="edit" slot-scope="text, record">
                        <a-space>
                            <a-button type="link" size="small" @click="$refs.emailHistoryDetailRef.show(record.email_id)">
                                {{ $t('submission.email_history_detail.click_to_view' /*点击查看*/) }}
                            </a-button>
                        </a-space>
                    </template>
                </s-table>
            </template>
            <!-- 模板发送记录 -->
            <template v-else>
                <s-table ref="templateTable" class="mt15" size="default" :rowKey="record => record.id" :columns="templateColumns" :data="templateLoadData" :showPagination="true" :scroll="{ x: 1500 }">
                    <template slot="num" slot-scope="text, record">
                        <b class="error-color">{{ record.num }}</b>
                    </template>
                    <template slot="send_time" slot-scope="text, record">
                        <span>{{ record.send_time }}</span>
                    </template>
                    <template slot="status" slot-scope="text, record">
                        <a-badge v-if="record.status == 1" :text="record.status_desc" status="success" />
                        <a-badge v-else-if="record.status == 3" :text="record.status_desc" status="blue" />
                        <a-badge v-else-if="record.status == 2" :text="record.status_desc" status="error" />
                        <a-badge v-else-if="record.status == 0" :text="record.status_desc" status="error" />
                    </template>
                </s-table>
            </template>
        </div>
        <email-history-detail ref="emailHistoryDetailRef"></email-history-detail>
    </a-drawer>
</template>

<script>
import emailHistoryDetail from './email-history-detail.vue';
import STable from '@/components/Table';
export default {
    name: 'EmailHistory',
    components: { STable, emailHistoryDetail },
    data() {
        return {
            visible: false,
            columns: [
                {
                    title: this.$t('submission.email_history_detail.email' /*邮箱*/),
                    dataIndex: 'target'
                },
                {
                    title: this.$t('submission.email_history_detail.num' /*数量（条）*/),
                    scopedSlots: { customRender: 'num' },
                    width: 110,
                    align: 'center'
                },
                {
                    title: this.$t('submission.email_history_detail.send_time' /*发送时间*/),
                    scopedSlots: { customRender: 'send_time' },
                    width: 200
                },
                {
                    title: this.$t('submission.email_history_detail.sender' /*发送者*/),
                    dataIndex: 'real_name',
                    width: 100
                },
                {
                    title: this.$t('submission.email_history_detail.send_status' /*发送状态*/),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    width: 120
                },
                {
                    title: this.$t('submission.email_history_detail.operator_send_status' /*运营商发送状态*/),
                    dataIndex: 'send_status_desc',
                    align: 'center',
                    width: 150
                },
                {
                    title: this.$t('submission.email_history_detail.send_return_value' /*发送返回值*/),
                    dataIndex: 'message_id'
                },
                {
                    title: this.$t('submission.email_history_detail.operation' /*操作*/),
                    width: 120,
                    align: 'center',
                    fixed: 'right',
                    scopedSlots: { customRender: 'edit' }
                }
            ],
            templateColumns: [
                {
                    title: this.$t('submission.email_history_detail.content' /*内容*/),
                    dataIndex: 'content'
                },
                {
                    title: this.$t('submission.email_history_detail.num' /*数量（条）*/),
                    scopedSlots: { customRender: 'num' },
                    width: 110,
                    align: 'center'
                },
                {
                    title: this.$t('submission.email_history_detail.send_time' /*发送时间*/),
                    dataIndex: 's_time',
                    width: 200
                },
                {
                    title: this.$t('submission.email_history_detail.sender' /*发送者*/),
                    dataIndex: 'real_name',
                    width: 100
                },
                {
                    title: this.$t('submission.email_history_detail.send_status' /*发送状态*/),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    width: 120
                },
                {
                    title: this.$t('submission.email_history_detail.operator_send_status' /*运营商发送状态*/),
                    dataIndex: 'send_status_desc',
                    align: 'center',
                    width: 150
                },
                {
                    title: this.$t('submission.email_history_detail.send_return_value' /*发送返回值*/),
                    dataIndex: 'message_id'
                }
            ],
            searchParams: {
                target: '',
                status: ''
            },
            totalCount: 0,
            tabIndex: 1, // 1 邮件发送记录 2 邮件模板记录
            loadData: parameter => {
                let data = {
                    ...parameter,
                    ...this.searchParams
                };
                return this.$request.get({ url: 'getEmailList', data }).then(res => {
                    this.totalCount = res.data.totalCount;
                    return res.data;
                });
            },
            templateLoadData: parameter => {
                let data = {
                    ...parameter,
                    ...this.searchParams
                };
                return this.$request.get({ url: 'getEmailTemplateLogList', data }).then(res => {
                    return res.data;
                });
            }
        };
    },
    computed: {},
    methods: {
        show() {
            this.visible = true;
            this.$nextTick(() => {
                this.handleSearch();
            });
        },
        handleChangeTypeEvent() {
            this.$nextTick(() => {
                if (this.tabIndex == 1) {
                    this.handleSearch();
                } else {
                    this.$refs.templateTable.refresh();
                }
            });
        },
        handleCancelEvent() {
            this.visible = false;
        },
        handleSearch() {
            this.$refs.table.refresh();
        }
    },
    created() {},
    mounted() {}
};
</script>
<style lang="less" scoped></style>
